/**
 * @pageName RestaurantsMenusManagementMenu
 * @slotType dashboard menu plugin
 */
export type MenuActionParam = { menuId: string };
